import React from 'react';
import PageRefs from './PageRefs';
import T from 'i18n';

const PageRefsPage = () => {
  return <PageRefs category={T.translate('case.pageRefs')} />;
};

export default PageRefsPage;
